import { getter } from "@progress/kendo-react-common";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { useNavigate } from "react-router";
import APP_ROUTES from "../../helper/app-routes";
import { AnnouncementServices } from "../../services/announcementService";
import moment from "moment";
import ReadBAAModal from "./baaReadBody";
import ReadByBAA from "./baaReadByClinics";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
function BAA() {
  const navigate = useNavigate();
  const announcementFiter = useSelector((state) => state?.announcementFiter);
  const [showBAAReadBy, setShowBAAReadBy] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = useState({});
  const [loading, setLoading] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [searchApiQuery, setsearchApiQuery] = useState([]);
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [showBAAHistoryDialog, setShowBAAHistoryDialog] = useState(false);

  const [showBaaDialog, setShowBaaDialog] = useState(false);
  const [selectedBaaBody, setSelectedBaaBody] = useState("");

  const [fields, setFields] = useState({
    clinicId: null,
    roleId: null,
    stateId: null,
    dateStart: moment().subtract(3, "days").startOf("day").format("M/D/YYYY"),
    dateEnd: moment().endOf("day").format("M/D/YYYY"),
  });

  const [keyword, setKeyword] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (announcementFiter) {
      setFields({
        dateStart: announcementFiter.dateStart,
        dateEnd: announcementFiter.dateEnd,
      });
    }
    getAnnouncements();
  }, []);

  const getAnnouncements = async () => {
    setLoading(true);
    const data = {
      clinicId: fields.clinicId?.id,
      roleId: fields.roleId?.id,
      stateId: fields.stateId?.id,
      title,
      dateStart: moment(fields.dateStart).format("M/D/YYYY"),
      dateEnd: moment(fields.dateEnd).format("M/D/YYYY"),
      keyword,
    };

    try {
      const result = await AnnouncementServices.get_Baa(data);
      setAnnouncements(result.resultData || []);
      setsearchApiQuery(result.resultData || []);
    } catch (error) {
      NOTIFICATION_MESSAGE.error(error);
    } finally {
      setLoading(false);
    }
  };

  const pageChange = (event) => {
    setPage(event.page.skip);
    setPageSize(event.page.take);
  };

  const handleAddBAA = () => {
    navigate(APP_ROUTES.ADD_BAA);
  };

  const handleShowBAAReadByDialog = () => {
    setShowBAAReadBy(true)
  }

  const handleCloseBaaDialog = () => {
    setShowBaaDialog(false);
    setSelectedBaaBody("");
  };

  return (
    <>
      <h4 className="address-title text-grey">
        <span className="f-24">Business Acknowledgement Agreement</span>
      </h4>

      <div className="d-flex justify-content-end mb-2">
        <button className="green-btn btn-primary mr-2" onClick={handleShowBAAReadByDialog}>
          BAA Acknowledged By
        </button>
        <button className="green-btn btn-primary mr-2" onClick={() =>
          navigate(APP_ROUTES.HISTORY_BAA)
        }>
          <span className="fas fa-history" style={{ color: "#fff" }} /> History
        </button>
        <button className="green-btn btn-primary" onClick={handleAddBAA}>
          <span className="fa fa-plus" style={{ color: "#fff" }} /> Add New
        </button>
      </div>

      <div className="grid-table filter-grid">
        {loading && <Loader />}
      <div className="custom-card bg-white">
                  
            <div className="flex-container">
          <div style={{ flex: 1, textAlign: "justify" }}>
                  <div
                  style={{float: 'right'}}
                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green"
                    onClick={() =>
                      // setShowChanges(true)
                      navigate(APP_ROUTES.ADD_BAA, {
                        state: {
                          baa: announcements[0],
                          isEdit: true,
                          isDuplicate: false
                        },
                      })
                    }
                  >
                    <Tooltip position="top" anchorElement="target">
                      <i title="Edit" className="fas fa-edit" />
                    </Tooltip>
                  </div>
                  </div></div>
                  <div className="flex-container">
                    <div style={{ flex: 1, textAlign: "justify" }}>
                      <span><b>Announcement Date</b></span>
                    </div>
                    <div style={{ flex: 1, textAlign: "justify" }}>
                      <span><b>Enforcement Date</b></span>
                    </div>
                  </div>

                  <div className="flex-container">
                    <div style={{ flex: 1, textAlign: "justify", fontWeight: "500" }}>
                      {announcements?.[0]?.announcementDate &&
                        moment(announcements[0].announcementDate)
                          .local()
                          .format("M/D/YYYY")}
                    </div>
                    <div style={{ flex: 1, textAlign: "justify", fontWeight: "500" }}>
                      {announcements?.[0]?.enforcementDate &&
                        moment(announcements[0].enforcementDate)
                          .local()
                          .format("M/D/YYYY")}
                    </div>
                  </div>

                  <div className="flex-container">
                    <div style={{ flex: 1, textAlign: "justify" }}>
                      <span><b>Agreement:</b></span>
                    </div>
                  </div>

                  <div className="flex-container">
                    <div style={{ flex: 1, textAlign: "justify", fontWeight: "500" }}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: announcements?.[0]?.body || ""
                        }}
                      />
                    </div>
                  </div>

        </div>
      </div>

      {/* Read BAA Modal */}
      {showBaaDialog && (
        <ReadBAAModal
          title={'Read BAA'} 
          onClose={handleCloseBaaDialog}
          message={selectedBaaBody}
        />
      )}
      {showBAAReadBy && (
        <ReadByBAA
          title={'BAA Acknowledged By'} 
          onClose={() => setShowBAAReadBy(false)}
        />
      )}
    </>
  );
}

export default BAA;
